import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TokenService } from '../../token/token.service';
import { map, Observable } from 'rxjs';
import {
  ADD_CART,
  CREATE_MARKETPLACE_CART,
  DELETE_CART,
  GET_MARKETPLACE_CART_GUSET,
  GET_MARKETPLACE_CART_USER,
  MARKETPLACE_CART_ASSIGN_USER,
  UPDATE_CART,
} from './shop.graphql';

@Injectable({
  providedIn: 'root',
})
export class ShopGraphqlService {
  constructor(
    private apollo: Apollo,
    private tokenService: TokenService,
  ) {}

  public createMarketplaceCart(): Observable<any> {
    const headers = new Headers();
    if (this.tokenService.accessToken)
      headers.append('Authorization', `Bearer ${this.tokenService.accessToken}`);

    return this.apollo
      .use('saleor')
      .mutate({
        mutation: CREATE_MARKETPLACE_CART,
        context: {
          headers: headers,
        },
      })
      .pipe(map((res: any) => res.data.marketplaceCartCreate.marketplaceCart));
  }

  public addMarketplaceCart(
    marketplaceCartId: string,
    channel: string,
    variantID: string,
    count: number,
  ): Observable<any> {
    const headers = new Headers();
    if (this.tokenService.accessToken)
      headers.append('Authorization', `Bearer ${this.tokenService.accessToken}`);

    return this.apollo
      .use('saleor')
      .mutate({
        mutation: ADD_CART,
        context: {
          headers: headers,
        },
        variables: {
          marketplaceCartAddId: marketplaceCartId,
          input: {
            channelSlug: channel,
            productVariantId: variantID,
            quantity: count,
          },
        },
      })
      .pipe(map((res: any) => res.data.marketplaceCartLineAdd?.marketplaceCart));
  }

  public marketplaceCartAssignUser(marketplaceCartId: string): Observable<any> {
    const headers = new Headers();
    if (this.tokenService.accessToken)
      headers.append('Authorization', `Bearer ${this.tokenService.accessToken}`);

    return this.apollo
      .use('saleor')
      .mutate({
        mutation: MARKETPLACE_CART_ASSIGN_USER,
        context: {
          headers: headers,
        },
        variables: {
          id: marketplaceCartId,
        },
      })
      .pipe(map((res: any) => res.data.marketplaceCartAssignUser?.marketplaceCart));
  }

  public updateMarketplaceCart(
    marketplaceCartLineUpdateId: string,
    quntity: number,
  ): Observable<any> {
    const headers = new Headers();
    if (this.tokenService.accessToken)
      headers.append('Authorization', `Bearer ${this.tokenService.accessToken}`);

    return this.apollo
      .use('saleor')
      .mutate({
        mutation: UPDATE_CART,
        context: {
          headers: headers,
        },
        variables: {
          marketplaceCartLineUpdateId: marketplaceCartLineUpdateId,
          input: {
            quantity: quntity,
          },
        },
      })
      .pipe(map((res: any) => res.data.marketplaceCartLineUpdate.marketplaceCart));
  }

  public deleteMarketplaceCart(marketplaceCartLineDeleteId: string): Observable<any> {
    const headers = new Headers();
    if (this.tokenService.accessToken)
      headers.append('Authorization', `Bearer ${this.tokenService.accessToken}`);

    return this.apollo
      .use('saleor')
      .mutate({
        mutation: DELETE_CART,
        context: {
          headers: headers,
        },
        variables: {
          marketplaceCartLineDeleteId: marketplaceCartLineDeleteId,
        },
      })
      .pipe(map((res: any) => res.data.marketplaceCartLineDelete.marketplaceCart));
  }

  public getMarketplaceCart(id?: string): Observable<any> {
    const options: any = {};

    if (!id) {
      const header = new Headers();
      header.append('Authorization', `Bearer ${this.tokenService.accessToken}`);

      options['context'] = {
        headers: header,
      };

      options['query'] = GET_MARKETPLACE_CART_USER;
    } else {
      options['query'] = GET_MARKETPLACE_CART_GUSET;
      options['variables'] = {
        marketplaceCartId: id,
      };
    }

    return this.apollo
      .use('saleor')
      .watchQuery(options)
      .valueChanges.pipe(map((res: any) => res.data.marketplaceCart));
  }
}
